
import { dias, horarios } from "@/core/data/tiemposFamilias";
import tratamientos from "@/core/data/tratamientos";
import { Menor, ServicioProgramado } from "@/store/models";
import moment from "moment";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

const getTextFromIds = (ids, options) => {
  if (!ids || ids.length === 0) {
    return "";
  }
  return options
    .filter((item) => ids.includes(item.id))
    .map((item) => item.text)
    .join(", ");
};

export default defineComponent({
  name: "formularios-familia-detalle-menor-item",
  props: {
    menor: { type: Object as () => Menor, required: true },
  },
  methods: {
    formatDate(fecha) {
      return moment(fecha).format("DD/MM/YYYY");
    },
    formatTiempo(tiempoItem) {
      // Obtenemos los textos traducidos para días y horas
      const diasTexto = getTextFromIds(tiempoItem.dias, dias);
      const horasTexto = getTextFromIds(tiempoItem.horas, horarios);

      // Formato: [Días seleccionados] - [Horas seleccionadas]
      return `${diasTexto} de ${horasTexto}`;
    },
  },
  setup(props) {
    const { t } = useI18n();

    const menoresSimple = computed(
      () => typeof props.menor?.lugarPrestacion === "undefined"
    );

    const tratamiento = computed(() => {
      const result = tratamientos.find(
        (tr) => tr.id === props.menor?.tratamiento
      );

      return result ?? tratamientos[3];
    });

    return {
      tratamiento,
      menorData: computed(() => props.menor),
      direccion: computed(
        () =>
          props.menor?.direccion ||
          props.menor?.servicioProgramado?.servicio.direccion
      ),
      servicioProgramado: computed(
        () => props.menor?.servicioProgramado || ({} as ServicioProgramado)
      ),
      lugarPrestacion: computed(() => {
        const lugarPrestacion = props.menor?.lugarPrestacion;
        const lugarEspacioColectivo = props.menor?.lugarEspacioColectivo;
        const otrosEspacioColectivo = props.menor?.otrosEspacioColectivo;

        if (lugarPrestacion !== "ESPACIO") {
          return t(`lugarPrestacion.${lugarPrestacion}`);
        }

        if (lugarEspacioColectivo !== "OTROS") {
          return t(`lugarEspacioColectivo.${lugarEspacioColectivo}`);
        }

        return otrosEspacioColectivo ?? "";
      }),
      tiemposFiltrados: computed(() => {
        // Usamos menorData en lugar de datosSolicitud
        return props.menor?.tiempos?.filter(
          (tiempo) =>
            (tiempo.dias && tiempo.dias.length > 0) ||
            (tiempo.horas && tiempo.horas.length > 0)
        );
      }),
      dias,
      horarios,
      menoresSimple,
    };
  },
});
